import React, { useState, useRef } from "react";
import { useLocation } from "react-router-dom";

import LokkingForCourses from "../../../../assets/images/business_team_looking_for_new_people.jpg";

import TeacherCardHome from "./teacherCardHome/TeacherCardHome";
import TeacherCard from "../teacherProfile/teacherCard/TeacherCard";
import Filters from "./filterTeacher/Filters";
import Select from "./filterTeacher/select/Select";

import { useWindowDimensions } from "../../../../utils/util";
import { langOptions } from "./filterTeacher/filterUtils";
import { DEFAULT_FILTERS } from "../../../../utils/constants";

import Navigation from "../../../../landing/components/Nav";
import styles from "./styles.module.css";
import Flag from "../../../../assets/icons/flag_icon.svg";

function FindTeacher() {

  const location = useLocation();
  const { width } = useWindowDimensions();

  const [showFilter, setShowFilter] = useState(false);
  const [focus, setFocus] = useState(false);
  const [coursesArr, setCoursesArr] = useState([]);
  const [lang, setLang] = useState(location.state?.lang || "Language");

  const [flagSrc, setFlagSrc] = useState(Flag);
  const resetRef = useRef();

  // Save default filters to localStorage if not already present
  React.useEffect(() => {
    if (!localStorage.getItem("allFilters")) {
      localStorage.setItem("allFilters", JSON.stringify(DEFAULT_FILTERS));
    }
  }, []);

  return (
    <div className={styles.container}>
      <Navigation />

      {/* Filters Section */}
      <div className={styles.filtersWrapper}>
        <div className={styles.filtersContainer}>
          {width >= 992 ? (
            <Filters
              focus={focus}
              setFocus={setFocus}
              width={width}
              courseArr={coursesArr}
              setCoursesArr={setCoursesArr}
              lang={lang}
              setLang={setLang}
              resetRef={resetRef}
            />
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div className={styles.mobileFilterControls}>
                <Select
                  name="lang"
                  options={langOptions}
                  value={lang}
                  setValue={setLang}
                  focus={focus}
                  setFocus={setFocus}
                  width={width}
                  flagSrc={flagSrc}
                  setFlagSrc={setFlagSrc}
                />
                <div
                  className={styles.mobileFilterBtn}
                  onClick={() => setShowFilter(!showFilter)}
                >
                  Filters <i className={`fas fa-chevron-${showFilter ? 'up' : 'down'}`} style={{ marginLeft: '8px' }}></i>
                </div>
              </div>

              {showFilter && (
                <div className={styles.mobileFilterExpanded}>
                  <Filters
                    focus={focus}
                    setFocus={setFocus}
                    width={width}
                    courseArr={coursesArr}
                    setCoursesArr={setCoursesArr}
                    lang={lang}
                    setLang={setLang}
                  />
                </div>
              )}
            </div>
          )}
        </div>

        {/* Courses Section */}
        <div
          className={styles.coursesSection}
          style={{ opacity: focus ? 0.2 : 1 }}
        >
          {coursesArr?.length > 0 ? (
            coursesArr.map((item, index) =>
              width >= 992 ? (
                <TeacherCardHome key={index} course={item} width={width} />
              ) : (
                <TeacherCard key={index} course={item} width={width} showFav />
              )
            )
          ) : (
            <div className={styles.emptyState}>
              <img
                src={LokkingForCourses}
                alt="no_course_found_img"
              />
              <div className={styles.emptyMessage}>
                Oops.. We are still looking for the perfect teacher/course for
                you. Please come back soon.
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default FindTeacher;
